<template>
  <div class="tbe-number-people">
    <tbe-dropdown
      class="tbe-number-people-dropdown"
      :is-hover="media.desktop"
      :is-full="true"
      :align="!media.desktop ? 'top-left' : 'bottom-left'"
    >
      <template #dropdown-trigger>
        <div class="">
          <label for="tbe-number-people" class="tbe-number-people__label">Number of people</label>
          <input
            id="tbe-number-people"
            class="tbe-input tbe-number-people-dropdown__control"
            :value="amountPeople"
            readonly="readonly"
          />
        </div>
      </template>
      <template #dropdown-content>
        <div class="tbe-number-people-dropdown__content">
          <div>
            <span>Participants</span><br />
            <small>(Age 69 and younger)</small>
          </div>
          <tbe-numeric-input
            :value="amountPeople"
            @change="handleChangeAmountPeople"
            :min="1"
            :max="product.capacity_max || 99"
            size="100px"
            align="center"
            :readonly-input="true"
          />
        </div>
      </template>
    </tbe-dropdown>
  </div>
</template>

<script>
  import { computed, watch } from 'vue'
  import { useStore } from 'vuex'

  import { useMedia } from 'common/plugins/media'
  import { RsDropdown as tbeDropdown, RsNumericInput as tbeNumericInput } from 'common/components'

  export default {
    name: 'tbeNumberPeople',

    components: { tbeDropdown, tbeNumericInput },

    setup() {
      const media = useMedia()
      const store = useStore()

      const product = computed(() => store.state.booking.product)

      const amountPeople = computed(() => store.state.booking.order.amountPeople)
      const setAmountPeople = (payload) => store.dispatch('booking/setAmountPeople', payload)

      const handleChangeAmountPeople = (value) => setAmountPeople(value)

      watch(
        () => product.value.capacity_max,
        (value) => {
          if (value > 1) setAmountPeople(2)
        },
        { immediate: true }
      )

      return { media, product, amountPeople, handleChangeAmountPeople }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-number-people-dropdown {
    &__control {
      width: 100%;
    }
    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
    }
  }

  .tbe-number-people {
    &__label {
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
</style>
